import { jsx as r, jsxs as W } from "@emotion/react/jsx-runtime";
import { useRef as C, useState as c, useEffect as L } from "react";
import { FocusOverlay as T } from "./FocusOverlay.js";
import { StyledBorderedBox as j, StyledSelectableCard as m } from "./SwitchButton.styled.js";
import { Tooltip as I } from "../Tooltip/index.js";
const U = ({
  dataTrackId: p,
  name: n,
  leftButton: e,
  rightButton: l,
  onChange: g,
  onFocus: u,
  onBlur: i,
  value: k,
  tooltip: w,
  className: b,
  disabled: x = !1
}) => {
  const t = C(null), o = C(null), [h, M] = c(), [f, R] = c(), [y, S] = c(!1), [a, D] = c(k === e.value ? e.value : l.value), v = (d) => {
    g?.(d), D(d.target.value);
  };
  L(() => {
    !t.current || !o.current || (M(t.current.getBoundingClientRect().width), R(o.current.getBoundingClientRect().width));
  }, [e.value, t, a, o]);
  const s = (d) => () => S(d);
  return /* @__PURE__ */ r(I, { text: w, children: /* @__PURE__ */ r("div", { style: {
    display: "inline-flex"
  }, className: b, "data-track": p, children: /* @__PURE__ */ W(j, { onMouseDown: s(!0), onMouseUp: s(!1), onMouseLeave: s(!1), "aria-disabled": x, children: [
    f && h ? /* @__PURE__ */ r(T, { focusPosition: a === e.value ? "left" : "right", rightCardWidth: f, leftCardWidth: h, hasMouseDown: y }) : null,
    /* @__PURE__ */ r(m, { dataTrackId: "", ref: t, name: n, value: e.value, checked: a === e.value, onChange: v, onBlur: i, onFocus: u, "data-checked": a === e.value, label: e.label, color: "default" }),
    /* @__PURE__ */ r(m, { dataTrackId: "", ref: o, name: n, value: l.value, checked: a === l.value, onChange: v, onBlur: i, onFocus: u, "data-checked": a === l.value, label: l.label, color: "default" })
  ] }) }) });
};
export {
  U as SwitchButton
};
